// extracted by mini-css-extract-plugin
module.exports = {"searchButton":"EmployerSearchItem_searchButton__2TWc8","searchButtonWrapper":"EmployerSearchItem_searchButtonWrapper__3zeAi","tag":"EmployerSearchItem_tag__1AN3-"};